import { LanguageCode } from '@/i18n/languages';
import { IdName } from '@/types/general';
import { TranslationSource } from '@/types/platform-data';
import { Tag } from '@/types/tags';
import { apiBaseUrl } from '@/utils/constants';

import { ENTITIES } from './api.constant';

const fields$base = (['id', 'name'] satisfies Array<keyof IdName>).join(',');

export async function tags$get$base(tagType: string): Promise<Tag[]> {
    const filter = encodeURIComponent(
        JSON.stringify({
            types: { type: { title: { _contains: tagType } } },
            status: { _eq: 'active' },
        }),
    );
    const deep = {};
    const url = `${apiBaseUrl}${ENTITIES.tags}?fields=${fields$base}&sort[]=name&filter=${filter}`;
    const response = await fetch(url, { next: { revalidate: 600 } }).then((res) => res.json());
    return response?.data ?? [];
}

const fields$translations = (['entity', 'language', 'nom'] satisfies Array<keyof TranslationSource>).join(',');

export async function tags$getTranslations(lang: LanguageCode, id: string[]): Promise<TranslationSource[]> {
    const filter = encodeURIComponent(JSON.stringify({ language: lang, entity: { _in: id } }));
    const url = `${apiBaseUrl}${ENTITIES.eventTagTranslations}?fields=${fields$translations}&filter=${filter}`;
    const response = await fetch(url).then((res) => res.json());
    return response?.data ?? [];
}
